export default {
	materialUnavailable: {
		singleLine1: "Le matériau de cet article n'est pas disponible.",
		singleLine2: "Cliquez ici pour modifier le matériau.",
		assemblyLine1:
			"Le matériau d'un ou plusieurs articles individuels de cet assemblage n'est pas disponible.",
		assemblyLine2: "Cliquez ici pour afficher les articles individuels.",
	},
	cad: {
		tooltipLine1: "Ouvre le modèle CAO dans le navigateur.",
		tooltipLine2:
			"Dans l'éditeur CAO intégré de Blexon, vous pouvez insérer / modifier des filetages, des lamages, des gravures, des cordons de soudure, etc.",
		tooltipLine3:
			"Vous pouvez également contrôler les dimensions, afficher les messages et corriger les causes d'erreurs.",
	},
	features: {
		label: "Traitements",
		basePrimed: "- apprêté",
		engraving: "Gravure",
	},
	info: {
		articleNumberLabel: "N° d'article:",
		blexonNumberLabel: "N° Blexon:",
		materialTypeLabel: "Matériau:",
		thicknessLabel: "Épaisseur:",
		topSideLabel: "Face supérieure",
		bottomSideLabel: "Face inférieure",
		quantityInAssemblyLabel: "Quantité dans l'assemblage:",
		dimensionsLabel: "LxlxH:",
		weightLabel: "Poids:",
		deburringLabel: "Ébavurage:",
		powderCoatingLabel: "Thermolaquage:",
		zincCoatingLabel: "Zingage:",
		certificateLabel: "Certificat:",
		certificateInfoTooltip: "Plus d'informations sur le certificat",
		noCoating: "Aucun",
		materialDivers: "Matériau: Divers",
		additionalDesignationGrinded: " / Poncé / Film",
		additionalDesignationAnodized: " / Film",
		additionalDesignationRibbed: " / Cannelé",
	},
	assembly: {
		moreText: "plus...",
		showSubarticlesButton: "Afficher les articles individuels",
		showSubarticlesTooltip: "Affiche tous les articles de cet assemblage.",
		calculatingMessage: "Certains articles de cet assemblage sont actuellement en cours de calcul.",
		noValidBodies:
			"L'assemblage ne contient aucun solide valide. Les solides sont peut-être ouverts ou définis uniquement comme surfaces.",
		checkSubarticlesHint:
			"Cliquez sur « Afficher les articles individuels » pour voir le statut de chaque article et effectuer les actions nécessaires sur ceux-ci.",
	},
	state: {
		errorHint:
			"Ouvrez l'article dans la CAO et vérifiez l'erreur, ou envoyez-le à notre service d'assistance pour une analyse gratuite.",
		infoHint:
			"Veuillez ouvrir l'article dans la CAO et définir ce qui doit être fait avec les traitements détectés.",
		inReview: "En vérification",
		ok: "OK",
		warning: "Avertissement",
		error: "Erreur",
		new: "Nouveau",
		actionRequired: "Action requise",
		unclear: "Indéterminé",
	},
	cart: {
		quantityPlaceholder: "Quantité",
		addToCartButton: "Au panier",
		addToCartTooltip: "Ajoute l'article au panier.",
		addedToCartSnackbar: "{quantity} pièce(s) ajoutée(s) au panier.",
		assemblyPartCannotOrder:
			"Les articles faisant partie d'un assemblage ne peuvent pas être commandés individuellement.",
		powderCoatingEngravingConflictLine1:
			"Les articles avec thermolaquage et gravure ne peuvent pas être commandés.",
		powderCoatingEngravingConflictLine2:
			"La gravure serait entièrement recouverte par le thermolaquage.",
		powderCoatingEngravingConflictLine3:
			"Retirez soit la gravure, soit le thermolaquage, afin de pouvoir commander l'article.",
		cannotBeProducedInRegion: "L'article ne peut actuellement pas être commandé en {region}.",
	},
	buttons: {
		openCad: "Afficher / modifier le modèle CAO",
		sendToHelpdesk: "Envoyer au service d'assistance",
		sendToHelpdeskTooltipLine1:
			"L'article est envoyé à notre service d'assistance et analysé gratuitement.",
		sendToHelpdeskTooltipLine2:
			"Vous serez informé dès que nous aurons traité votre article.",
		blexonize: "Blexoniser l'article",
		blexonizeTooltipLine1: "L'article n'a pas encore été blexonisé avec la version la plus récente.",
		blexonizeTooltipLine2:
			"Pour commander l'article, le vérifier ou le modifier dans la CAO, cliquez ici.",
	},
	messages: {
		checkCartMembershipError:
			"Il n'est actuellement pas possible de vérifier si l'article est utilisé dans une nomenclature.",
	},
	header: {
		selectForMultiActionTooltip:
			"Sélectionner pour une action multiple. Les actions possibles s'affichent en haut.",
		contextMenuTooltip: "Ouvre le menu contextuel de l'article.",
		edit: "Modifier",
		delete: "Supprimer",
		unlock: "Déverrouiller",
		lock: "Verrouiller",
	},
	pricelist: {
		openTooltip: "Ouvre la liste des prix de l'article.",
		button: "Liste de prix",
		pricesNotCalculatedLine1: "Les prix de cet article n'ont pas pu être calculés.",
		pricesNotCalculatedLine2:
			"Veuillez envoyer l'article à notre service d'assistance pour une analyse gratuite.",
		priceInfoTooltip:
			"Découvrez ici comment obtenir vos articles à un prix encore plus avantageux.",
		priceHintLabel: "Remarque sur les prix",
		pricePerUnitMulti: "Prix / pce [{currency}]",
		pricePerUnitSingle: "Prix/pce [{currency}]",
		quantityLabel: "Quantité",
		fromQuantity: "dès {quantity}",
		addQuantityToCartTooltip: "{quantity} pièce(s) au panier",
		hintTitle: "Vous verrez le prix final incluant la remise de quantité dans le panier.",
		hintText:
			"Plusieurs articles avec les mêmes traitements ou le même matériau entraînent une réduction de prix. Pour calculer le prix définitif, veuillez composer un panier et obtenir en quelques secondes une offre incluant le délai de livraison.",
		loadError: "Les prix de l'article n'ont pas pu être chargés.",
	},
};
